import { useEffect } from 'react';
import { updatePageMeta } from '../utils/seo';
import Hero from '../components/Hero';
import WorkSection from '../components/WorkSection';

function Home() {
  useEffect(() => {
    updatePageMeta(
      'Stephanie Zhang - Portfolio',
      'UI/UX Designer creating thoughtful digital experiences. Portfolio showcasing design work and projects.'
    );
  }, []);

  return (
    <>
      <Hero />
      <WorkSection />
    </>
  );
}

export default Home;

